import React, { useState, createContext, useCallback } from "react";

interface IMenuOption {
  key: string;
  path: string;
  icon: string;
  label: string;
}
interface IDrawerContextData {
  isDrawerPersistent: boolean;
  menuOptions: IMenuOption[];
  toggleDrawer(): void;
  drawerWidth: number;
  isOpen: boolean;
}
export const DrawerContext = createContext<IDrawerContextData>(
  {} as IDrawerContextData,
);

export const DrawerProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const menuOptions: IMenuOption[] = [
    {
      icon: "list_alt",
      key: "minhas-reservas",
      path: "/minhas-reservas",
      label: "Minhas Reservas",
    },
    {
      icon: "add_box",
      key: "nova-reserva",
      path: "/nova-reserva",
      label: "Nova Reserva",
    },
  ];

  /** Alterna o contexto do drawer entre aberto e fechado */
  const handleToggleDrawer = useCallback(() => {
    setDrawerState((oldState) => {
      return {
        ...oldState,
        isOpen: !oldState.isOpen,
      };
    });
  }, []);

  const [drawerState, setDrawerState] = useState<IDrawerContextData>({
    toggleDrawer: handleToggleDrawer,
    isDrawerPersistent: false,
    drawerWidth: 240,
    isOpen: false,
    menuOptions,
  });

  return (
    <DrawerContext.Provider value={drawerState}>
      {children}
    </DrawerContext.Provider>
  );
};
